module.exports = "/_next/static/pages/test-guidelines/e4a7ef6267b710b916bbe83e04de5231.png";